// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__37T1W","title-container":"style_title-container__nJyXL","avatar":"style_avatar__I9T18"};